<div style="padding: 15px 0px;">
  <div [innerHTML]="question.content.text | replacePatientTerm : question.content.patientTerms : patientTerm | sanitizeHtml"></div>

  <form class="form">
      <mat-form-field class="full-width">
        <textarea type="text"
                [ariaLabel]="question.content.text"
                matInput             
                [formControl]="myControl"
                [matAutocomplete]="auto"
                #myInput = "cdkTextareaAutosize"
                cdkTextareaAutosize 
                cdkAutosizeMaxRows="4"
                style="overflow:hidden"
                [placeholder]="placeholderText">
        </textarea>

        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="saveSelection($event.option.value)"  [displayWith]="displaySelection">
          <mat-option data-test-id="dropDownListQuestion"  *ngFor="let option of filteredOptions | async" [value]="option" >
            {{ option.content.text! | replacePatientTerm : option.content.patientTerms : patientTerm }} 
          </mat-option>
        </mat-autocomplete>

        <button matSuffix mat-icon-button aria-label="Clear" *ngIf="myControl.getRawValue() !== null && myControl.getRawValue() !== ''" (click)="clearSelectedValue()">
          <mat-icon>close</mat-icon>
        </button> 

        <mat-error *ngFor="let validation of validation_msgs.contactAutocompleteControl">
          <div *ngIf="myControl.hasError(validation.type)" class="error-message" i18n>
            {{validation.message}}
          </div>
        </mat-error>
      </mat-form-field>
  </form>
  <mat-divider></mat-divider>
</div>